import type { FastifyInstance } from 'fastify'
import { authMiddleware } from '../../middleware/auth.middleware.js'
import { handleConsoleErrors } from './logging.controller.js'

export async function registerLoggingRoutes(fastify: FastifyInstance): Promise<void> {
  /**
   * POST /api/logging/console-errors
   * Receive console errors from browser clients
   * Authentication: Required (Bearer token)
   * Rate limited: Yes (10 requests per minute per user)
   */
  fastify.post(
    '/console-errors',
    {
      preHandler: [authMiddleware],
      schema: {
        description: 'Log console errors from browser',
        tags: ['Logging'],
        response: {
          202: {
            type: 'object',
            properties: {
              received: { type: 'number' }
            }
          }
        }
      }
    },
    handleConsoleErrors
  )
}
